import axios from "../../../../api/axios";
import { User } from "../../../../types/types";

import { Plan, SubscriptionPlanOption } from "../../types/plans";

type CurrentPlanResponse = {
  subscribed: boolean;
  data: {
    plan: Plan;
  };
  message: string;
};

export const getCurrentPlan = async () => {
  const response = await axios.get<CurrentPlanResponse>("/subscriptions/current-plan");
  return response;
};

type CreateSubscriptionResponse = {
  data: {
    subscription: {
      clientSecret: string;
      publishableKey: string;
      subscription: {
        startDate: string;
        endDate: string;
        status: string;
        user: User;
        subscriptionPlan: SubscriptionPlanOption;
        id: number;
      };
    };
  };
  message: string;
};

export const createSubscriptionService = async (subscriptionPlanId: number) => {
  const response = await axios.post<CreateSubscriptionResponse>("/subscriptions", { subscriptionPlanId });
  return response.data.data;
};

type UpgradeSubscriptionResponse = {
  data: {
    upgraded: boolean;
    subscriptionId: number;
    oldPlanId: number;
    newPlanId: number;
    amountCents: number;
    remainingRatio: number;
    clientSecret: string;
    publishableKey: string;
  };
  message: string;
};

export const upgradeSubscriptionService = async (subscriptionPlanId: number) => {
  const response = await axios.post<UpgradeSubscriptionResponse>("/subscriptions/upgrade", {
    newPlanId: subscriptionPlanId,
    prorate: true,
  });
  return response.data.data;
};
